import { useSelector } from "react-redux";
import { MasterConfigs } from "../../interfaces/entity";
import { Typography } from "antd";

const { Title } = Typography;

export const useEducationConfig = () => {
    const { app: { user } } = useSelector((state: any) => ({
        app: state.app
    }));

    const EducationConfig: MasterConfigs = {
        api: () => `/educations/${user?._id}`,
        modalTitle: () => "Edit User",
        maskClosable: false,
        getFormColumns: () => [
            {
                type: "custom",
                formItem: () => <Title level={5}>Work Experience</Title>,
                span: 24
            },
            {
                label: "Educations",
                name: "education",
                type: "form",
                span: 24,
                form: [
                    {
                        label: "Degree",
                        name: "degree",
                        type: "text",
                        rules: [{ required: true, message: "Degree is required" }]
                    },
                    {
                        label: "Institute Name",
                        name: "institueName",
                        type: "text",
                        rules: [{ required: true, message: "Institute Name is required" }]
                    },
                    {
                        label: "Specialization",
                        name: "specialization",
                        type: "text",
                        rules: [{ required: true, message: "Specialization is required" }]
                    },
                    {
                        label: "University Name",
                        name: "University",
                        type: "text",
                        rules: [{ required: true, message: "University Name is required" }]
                    },
                    {
                        label: "Grade",
                        name: "grade",
                        type: "text",
                        rules: [{ required: true, message: "Grade is required" }]
                    },
                    {
                        label: "Percentage",
                        name: "percentage",
                        type: "text",
                        rules: [{ required: true, message: "Percentage is required" }]
                    },
                    {
                        label: "Start Date",
                        name: "startDate",
                        type: "date",
                        dateProps: { format: "DD MMM YYYY" },
                        rules: [{ required: true, message: "Start Date is required" }]
                    },
                    {
                        label: "End Date",
                        name: "endDate",
                        type: "date",
                        dateProps: { format: "DD MMM YYYY" },
                        rules: [{ required: true, message: "End Date is required" }]
                    },
                ]
            }
        ]
    };

    return EducationConfig;
};
